const SITE_URL = 'https://www.gitedenlebe.fr';

const DEFAULT_DESCRIPTION =
	"Située au cœur d'une ferme biologique à Touget dans le Gers, le Gîte d'en Lébé propose un gîte de groupe, des chambres d'hôtes et l'escale pour 2 personnes. 3 épis Gîtes de France, piscine privative, wifi gratuit.";

const routeSeo = {
	'/': {
		title: "Gîte en Lébé — Gîtes & Chambres d'Hôtes, Gers 32",
		description: DEFAULT_DESCRIPTION,
	},
	'/contact': {
		title: "Contact et itinéraire — Gîte d'en Lébé, Touget",
		description:
			"Contactez Anne et Hervé au Gîte d'en Lébé à Touget (Gers). Formulaire, téléphone, plan d'accès et itinéraires pour rejoindre notre gîte.",
	},
	'/nos-hebergements': {
		title: "Nos hébergements — Gîte, chambres d'hôtes, escale",
		description:
			"Découvrez nos hébergements au Gîte d'en Lébé : grand gîte jusqu'à 15 personnes, chambres d'hôtes et petit gîte l'escale pour 2 personnes.",
	},
	'/tarifs-et-reservation': {
		title: "Tarifs et réservations — Gîte d'en Lébé",
		description:
			"Consultez les tarifs et réservez votre séjour au Gîte d'en Lébé à Touget. Meilleur tarif en réservation directe, conseils personnalisés des propriétaires.",
	},
	'/votre-sejour': {
		title: 'Votre séjour dans le Gers — Activités et visites',
		description:
			"Organisez votre séjour au Gîte d'en Lébé : activités, visites et découvertes dans le Gers et la Gascogne, à proximité de Gimont et Toulouse.",
	},
	'/reservations-studio': {
		title: "Réserver l'escale — Gîte d'en Lébé",
		description:
			"Réservez l'escale, charmant petit gîte pour 1 ou 2 personnes au Gîte d'en Lébé à Touget. Consultez les disponibilités et réservez en ligne.",
	},
	'/reservations-petit-gite': {
		title: "Réserver le petit gîte — Gîte d'en Lébé",
		description:
			"Réservez le petit gîte du Gîte d'en Lébé à Touget dans le Gers. Consultez les disponibilités et réservez directement en ligne.",
	},
	'/reservations-gite': {
		title: "Réserver le grand gîte — Gîte d'en Lébé",
		description:
			"Réservez le grand gîte du Gîte d'en Lébé à Touget, capacité jusqu'à 15 personnes. Consultez les disponibilités et réservez en ligne.",
	},
	'/aerodrome': {
		title: 'Aérodrome de Touget — Accès par les airs',
		description:
			"Rejoignez le Gîte d'en Lébé par les airs via l'aérodrome de Touget. Piste privée, informations et contact pour les pilotes.",
	},
	'/actualites': {
		title: "Actualités — Gîte d'en Lébé",
		description:
			"Suivez les actualités du Gîte d'en Lébé à Touget : événements, nouveautés et informations pour vos vacances dans le Gers.",
	},
	'/epicerie': {
		title: "L'épicerie — Gîte d'en Lébé",
		description:
			"Découvrez l'épicerie itinérante et traditionnelle de Nanou, partenaire du Gîte d'en Lébé à Touget dans le Gers.",
	},
};

const hebergementSeo = {
	'le-gite': {
		title: 'Le gîte — Location 15 personnes, Touget (Gers)',
		description:
			"Louez le grand gîte d'en Lébé à Touget : 290 m², jusqu'à 15 personnes, piscine privative, 3 épis Gîtes de France, labellisé Tourisme & Handicap.",
	},
	studio: {
		title: "L'escale — Petit gîte 2 personnes, Touget",
		description:
			"L'escale est un charmant petit gîte pour 1 ou 2 personnes au Gîte d'en Lébé à Touget. Confortable, climatisé, idéal pour un week-end dans le Gers.",
	},
	'chambres-d-hotes': {
		title: "Chambres d'hôtes — Gîte d'en Lébé, Touget",
		description:
			"3 chambres d'hôtes de caractère au rez-de-chaussée du Gîte d'en Lébé à Touget. Climatisées, petit-déjeuner fait maison, une chambre accessible PMR.",
	},
};

export function getSeoForRoute(route) {
	const path = route.path;

	if (route.name === 'HebergementItem' && route.params.type) {
		const seo = hebergementSeo[route.params.type] || hebergementSeo['le-gite'];
		return {
			...seo,
			canonical: `${SITE_URL}/nos-hebergements/${route.params.type}`,
		};
	}

	if (route.name === 'ActuItem') {
		return {
			title: "Actualité — Gîte d'en Lébé",
			description: DEFAULT_DESCRIPTION,
			canonical: `${SITE_URL}${path}`,
		};
	}

	const seo = routeSeo[path] || routeSeo['/'];
	const canonical = path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`;

	return {
		...seo,
		canonical,
	};
}
